import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { FormattedMessage } from 'react-intl';

import { fetchProduct } from 'Api/Product/product-service';
import imgixConfig from 'Config/imgix';
import SpecialFormattedNumber from 'Components/Utility/Price/SpecialFormattedNumber';

import 'Components/Banner/ProductSlimBanner/ProductSlimBanner.scss';

export default function ProductSlimBanner() {
  const [product, setProduct] = useState({});

  const slugToFind = 'command-modern-operations';

  useEffect(() => {
    const loadProduct = async () => {
      if (!slugToFind) return false;

      return fetchProduct(slugToFind)
        .then((result) => {
          if (result.notFound) {
            return false;
          }
          return setProduct(result.product);
        });
    };

    loadProduct();
  }, [slugToFind]);

  if (isEmpty(product)) return false;

  const type = get(product, 'type', '');
  const name = get(product, 'name', '');
  const slug = get(product, 'slug', '');
  const currentDiscount = get(product, 'current_discount', {});
  const currentDiscountPercent = get(currentDiscount, 'percent', 0);

  if (currentDiscountPercent === 0) return false;

  return (
    <Link to={`/${type}/${slug}`} className="ProductSlimBanner">
      <div className="container ProductSlimBanner__container">
        <div className="ProductSlimBanner__content">
          <FormattedMessage
            id="product-slim-banner.message"
            defaultMessage="Get the {title} base game for {percent} off now!"
            values={{
              title: name,
              percent: <SpecialFormattedNumber value={currentDiscountPercent} style="percent" />,
            }}
          />

          <div className="ProductSlimBanner__button">
            <FormattedMessage
              id="product-slim-banner.button"
              defaultMessage="View product"
            />
          </div>
        </div>
      </div>
      <div className="ProductSlimBanner__background">
        <img
          srcSet={`
                https://fanatical.imgix.net/production/assets/banners/command-modern-operations-slim-banner-background.jpg?${imgixConfig}&w=2648&h=160&fit=crop 2648w,
                https://fanatical.imgix.net/production/assets/banners/command-modern-operations-slim-banner-background.jpg?${imgixConfig}&w=1986&h=120&fit=crop 1986w,
                https://fanatical.imgix.net/production/assets/banners/command-modern-operations-slim-banner-background.jpg?${imgixConfig}&w=1324&h=80&fit=crop 1324w,
                https://fanatical.imgix.net/production/assets/banners/command-modern-operations-slim-banner-background.jpg?${imgixConfig}&w=993&h=60&fit=crop 993w,
                https://fanatical.imgix.net/production/assets/banners/command-modern-operations-slim-banner-background.jpg?${imgixConfig}&w=662&h=40&fit=crop 662w
              `}
          sizes="100vw"
          src={`https://fanatical.imgix.net/production/assets/banners/command-modern-operations-slim-banner-background.jpg?${imgixConfig}&w=1324&h=80&fit=crop`}
          alt={name}
        />
      </div>
    </Link>
  );
}
